var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"appDescriptionContainer"},[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"description text-xs-center"},[_vm._v("\n        "+_vm._s(_vm.productDescription)+"\n      ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }